export const AuthDrawerEnum = {
  LOGIN: "login",
  REGISTER: "register",
  FORGOT: "forgot",
  RECOVERY: "recovery",
} as const;

export type AuthDrawerType =
  (typeof AuthDrawerEnum)[keyof typeof AuthDrawerEnum];
